import React, { Component } from 'react';
import classNames from 'classnames';
import { REACT_APP_API_BASE } from '../../config';
import Takeover from '../../components/takeover';
import Success from '../../components/spinner/success';
import SpinnerDots from  '../../components/spinner/dots';

class Feedback extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            isSending: false,
            isFinished: false,
            isLoadingFeedbackForm: true,
            feedback: {}
        }
    }

    async componentDidUpdate(prevProps, prevState) {
        if (!this.props.isAuthenticated) return;

        if (!prevState.isOpen && this.state.isOpen) {
            
            this.setState({
                isLoadingFeedbackForm: true
            });

            const form = await this.loadFeedbackForm();

            this.setState({
                feedback: {
                    ...form
                },
                isLoadingFeedbackForm: false
            });
        }
    }

    async toggleFeedbackForm() {
        this.setState({
            isOpen: !this.state.isOpen,
        }, () => {
            setTimeout(() => {
                if (!this.state.isOpen) {
                    this.setState({
                        isLoadingFeedbackForm: true,
                        isFinished: false
                    });
                }
            }, 300);
        });
    }

    async loadFeedbackForm() {
        const route = this.props.match;
        const res = await this.props.fetch(`${REACT_APP_API_BASE}/units/${route.params.unitId}/notifychanges`); 
        if (!res.ok) {
            //handle 404
        }
        return res.json();
    }

    updateValues(value, param, parentParam) {
        const feedback = { ...this.state.feedback };

        if (parentParam) {
            feedback[parentParam][param] = value;
        } else {
            feedback[param] = value;
        }

        this.setState({
            feedback
        });
    }

    async sendFeedback() {
        this.setState({
            isSending: true
        });

        const token = await this.props.getAccessToken();
        const headers = new Headers();
        const bearer = `Bearer ${token}`;
        headers.append('Authorization', bearer);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');

        const path = `${REACT_APP_API_BASE}/units/notifychanges`;
        try {
            const rawResponse = await fetch(path, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    ...this.state.feedback
                })
            });
        
            if (rawResponse.ok) {
                this.setState({
                    isSending: false,
                    isFinished: true
                });
            }
        } catch(e) {
            this.setState({
                isSending: false,
                isFinished: false
            });
        }
    }

    render() {

        return (
            <>
                <button type="button" className="unit__message-btn" onClick={() => this.toggleFeedbackForm()}>Lämna feedback</button>
                <Takeover isOpen={this.state.isOpen} 
                            toggleTakeover={() => this.toggleFeedbackForm()} 
                            heading={this.state.isFinished ? 'Tack för din feedback!' : 'Meddela Delfi felaktigt data'}
                            modifiers={{
                            'takeover--wide-xl': true
                            }}>
                    <div className={classNames({
                        'unit__message': true,
                        'unit__message--is-loading': this.state.isLoadingFeedbackForm
                    })}>
                        {!this.state.isFinished &&
                            <div className={classNames({
                                'unit__message-form': true,
                                'unit__message-form--is-sending': this.state.isSending
                            })}>
                                <p>
                                    Här kan du skicka korrigeringar till oss.
                                </p>
                                <div className="unit__message-coumns">
                                    <div className="unit__message-col">
                                        <label htmlFor="UnitName">Namn</label>
                                        <input id="UnitName" type="text" value={this.state.feedback.UnitName} onChange={(e) => this.updateValues(e.currentTarget.value, 'UnitName')} />
                                        
                                        <label htmlFor="LegalName">Juridiskt namn</label>
                                        <input id="LegalName" type="text" value={this.state.feedback.LegalName} onChange={(e) => this.updateValues(e.currentTarget.value, 'LegalName')} />

                                        <label htmlFor="CorporateIdentityNumber">Organisationsnummer</label>
                                        <input id="CorporateIdentityNumber" type="text" value={this.state.feedback.CorporateIdentityNumber} onChange={(e) => this.updateValues(e.currentTarget.value, 'CorporateIdentityNumber')} />
                                        
                                        <label htmlFor="StoreManager">Kontaktperson</label>
                                        <input id="StoreManager" type="text" value={this.state.feedback.StoreManager} onChange={(e) => this.updateValues(e.currentTarget.value, 'StoreManager')} />

                                        <label htmlFor="Telephone">Telefon</label>
                                        <input id="Telephone" type="text" value={this.state.feedback.Telephone} onChange={(e) => this.updateValues(e.currentTarget.value, 'Telephone')} />

                                        <label htmlFor="Telefax">Fax</label>
                                        <input id="Telefax" type="text" value={this.state.feedback.Telefax} onChange={(e) => this.updateValues(e.currentTarget.value, 'Telefax')} />
                                        
                                        <label htmlFor="Email">E-post</label>
                                        <input id="Email" type="text" value={this.state.feedback.Email} onChange={(e) => this.updateValues(e.currentTarget.value, 'Email')} />
                                        
                                        <label htmlFor="VisitingAddress">Besöksadress</label>
                                        <input id="VisitingAddress" type="text" value={this.state.feedback.VisitingAddress && this.state.feedback.VisitingAddress.Address} onChange={(e) => this.updateValues(e.currentTarget.value, 'Address', 'VisitingAddress')} />
                                    </div>
                                    <div className="unit__message-col">
                                        <label htmlFor="Latitud">Latitud</label>
                                        <input id="Latitud" type="text" value={this.state.feedback.Latitude} onChange={(e) => this.updateValues(e.currentTarget.value, 'Latitude')} />

                                        <label htmlFor="Longitud">Longitud</label>
                                        <input id="Longitud" type="text" value={this.state.feedback.Longitude} onChange={(e) => this.updateValues(e.currentTarget.value, 'Longitude')} />
                                        
                                        <label htmlFor="VisitingPostalCode">Postnummer</label>
                                        <input id="VisitingPostalCode" type="text" value={this.state.feedback.VisitingAddress && this.state.feedback.VisitingAddress.PostalCode} onChange={(e) => this.updateValues(e.currentTarget.value, 'PostalCode', 'VisitingAddress')} />

                                        <label htmlFor="VisitingCity">Ort</label>
                                        <input id="VisitingCity" type="text" value={this.state.feedback.VisitingAddress && this.state.feedback.VisitingAddress.City} onChange={(e) => this.updateValues(e.currentTarget.value, 'City', 'VisitingAddress')} />

                                        <label htmlFor="PostalAddress">Box-adress</label>
                                        <input id="PostalAddress" type="text" value={this.state.feedback.PostalAddress && this.state.feedback.PostalAddress.Address} onChange={(e) => this.updateValues(e.currentTarget.value, 'Address', 'PostalAddress')} />
                                        
                                        <label htmlFor="PostalCode">Postnummer</label>
                                        <input id="PostalCode" type="text" value={this.state.feedback.PostalAddress && this.state.feedback.PostalAddress.PostalCode} onChange={(e) => this.updateValues(e.currentTarget.value, 'PostalCode', 'PostalAddress')} />
                                        
                                        <label htmlFor="PostalCity">Ort</label>
                                        <input id="PostalCity" type="text" value={this.state.feedback.PostalAddress && this.state.feedback.PostalAddress.City} onChange={(e) => this.updateValues(e.currentTarget.value, 'City', 'PostalAddress')} />
                                        
                                        <label htmlFor="WholesaleName">Grossist</label>
                                        <input id="WholesaleName" type="text" value={this.state.feedback.WholesaleName} onChange={(e) => this.updateValues(e.currentTarget.value, 'WholesaleName')} />
                                        
                                        <label htmlFor="WholesaleCustomerCode">Kundnummer grossist</label>
                                        <input id="WholesaleCustomerCode" type="text" value={this.state.feedback.WholesaleCustomerCode} onChange={(e) => this.updateValues(e.currentTarget.value, 'WholesaleCustomerCode')} />
                                        
                                        <label htmlFor="TypeName">Typ</label>
                                        <input id="TypeName" type="text" value={this.state.feedback.TypeName} onChange={(e) => this.updateValues(e.currentTarget.value, 'TypeName')} />
                                    
                                    </div>
                                    <div className="unit__message-col unit__message-col--wide">
                                        <label htmlFor="OtherInformationString">Övrig info</label>
                                        <textarea id="OtherInformationString" type="text" value={this.state.feedback.OtherInformationString} onChange={(e) => this.updateValues(e.currentTarget.value, 'OtherInformationString')}></textarea>
                                    
                                        <label htmlFor="AssortmentString">Sortiment</label>
                                        <textarea id="AssortmentString" type="text" value={this.state.feedback.AssortmentString} onChange={(e) => this.updateValues(e.currentTarget.value, 'AssortmentString')}></textarea>
                                    </div>
                                </div>
                                <div className="unit__message-form-maxwidth">
                                    <div className={classNames({
                                        'export-raw': true,
                                    })}>
                                        <div className="export-raw__content">
                                            <button className="export-footer__button" type="button" onClick={async () => await this.sendFeedback()} disabled={this.state.isSending}>{this.state.isSending ? 'Skickar' : 'Skicka'}</button>
                                            <button className="export-raw__close" type="button" onClick={() => this.toggleFeedbackForm()}>Avbryt</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                        {this.state.isFinished &&
                            <div className="unit__message-form-maxwidth">
                                <div className={classNames({
                                    'districts__takeover-success': true,
                                    'districts__takeover-success--is-finished': this.state.isFinished
                                })}>
                                    <Success isFinished={this.state.isFinished} />
                                    <div className="districts__takeover-controls">
                                        <button onClick={() => this.toggleFeedbackForm()} className="districts__takeover-controls-btn districts__takeover-controls-btn--outline" type="button">Stäng</button>
                                    </div>
                                </div>
                            </div>
                        }
                        <SpinnerDots />
                    </div>
                </Takeover>
            </>
        );
       
    }
}

export default Feedback;